export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const CREATE_ADMIN_START = 'CREATE_ADMIN_START';
export const CREATE_ADMIN_END = 'CREATE_ADMIN_END';
export const FETCH_ADMINS_START = 'FETCH_ADMINS_START';
export const FETCH_ADMINS_END = 'FETCH_ADMINS_END';
export const UPDATE_ADMIN_STATE = 'UPDATE_ADMIN_STATE';
export const DELETE_ADMIN_START = 'DELETE_ADMINS_START';
export const DELETE_ADMIN_END = 'DELETE_ADMINS_END';

export const FETCH_USERS_START = 'FETCH_USERS_START';
export const FETCH_USERS_END = 'FETCH_USERS_END';
// export const UNVERIFY_USERS_START = 'UNVERIFY_USERS_START'
// export const UNVERIFY_USERS_END = 'UNVERIFY_USERS_END'

export const FETCH_APP_USERS_START = 'FETCH_APP_USERS_START';
export const FETCH_APP_USERS_END = 'FETCH_APP_USERS_END';

export const UPDATE_APP_USERS_START = 'UPDATE_APP_USERS_START';
export const UPDATE_APP_USERS_END = 'UPDATE_APP_USERS_END';

export const WRITE_CART_END = 'WRITE_CART_END';
export const CLEAR_CART_END = 'CLEAR_CART_END';
export const TRIM_CART_END = 'TRIM_CART_END';

export const FETCH_LIST_START = 'FETCH_LIST_START';
export const FETCH_LIST_END = 'FETCH_LIST_END';
export const DL_LIST_START = 'DL_LIST_START';
export const DL_LIST_END = 'DL_LIST_END';

export const FETCH_ROOMS_START = 'FETCH_ROOMS_START';
export const FETCH_ROOMS_END = 'FETCH_ROOMS_END';
// store = synchronus action
// start -> server = asynchronus action
export const ADD_ROOM_STORE = 'ADD_ROOM_STORE';
export const ADD_ROOM_START = 'ADD_ROOM_START';
export const ADD_ROOM_SERVER = 'ADD_ROOM_SERVER';
export const UPDATE_ROOM_START = 'UPDATE_ROOM_START';
export const UPDATE_ROOM_END = 'UPDATE_ROOM_END';
// store = synchronus action
// start -> server = asynchronus action
export const DELETE_ROOM_STORE = 'DELETE_ROOM_STORE';
export const DELETE_ROOM_START = 'DELETE_ROOM_START';
export const DELETE_ROOM_SERVER = 'DELETE_ROOM_SERVER';

export const WRITE_QRCODE_END = 'WRITE_QRCODE_END';
export const CLEAR_QRCODE_END = 'CLEAR_QRCODE_END';
export const DELETE_QRCODE_END = 'DELETE_QRCODE_END';

export const ASYNC_SUCCESS = 'ASYNC_SUCCESS';
export const ASYNC_FAIL = 'ASYNC_FAIL';
export const CLEAR_ALERT = 'CLEAR_ALERT';

export const UPDATE_QRCODE_STORE = 'UPDATE_QRCODE_STORE';

export const FETCH_PRODUCTS_START = 'FETCH_PRODUCTS_START';
export const FETCH_PRODUCTS_END = 'FETCH_PRODUCTS_END';
export const FETCH_ALL_PRODUCTS_END = 'FETCH_ALL_PRODUCTS_END';
export const GET_FILTER_TYPOLOGY_END = 'GET_FILTER_TYPOLOGY_END';
export const UPDATE_PRODUCT_START = 'UPDATE_PRODUCT_START';
export const UPDATE_PRODUCT_END = 'UPDATE_PRODUCT_END';

export const FETCH_PROMOS_START = 'FETCH_PROMOS_START';
export const FETCH_PROMOS_END = 'FETCH_PROMOS_END';
export const FETCH_PROMO_START = 'FETCH_PROMO_START';
export const FETCH_PROMO_END = 'FETCH_PROMO_END';
export const DELETE_PROMODUCT = 'DELETE_PROMODUCT';
export const PUT_PROMODUCTS = 'PUT_PROMODUCTS';
export const NOTIFY_PROMO_START = 'NOTIFY_PROMO_START';
export const NOTIFY_PROMO_END = 'NOTIFY_PROMO_END';
export const UPDATE_HIGHLIGHTED_PROMOS = 'UPDATE_HIGHLIGHTED_PROMOS';

export const FETCH_PRODUCT_TYPES_START = 'FETCH_PRODUCT_TYPES_START';
export const FETCH_PRODUCT_TYPES_END = 'FETCH_PRODUCT_TYPES_END';

export const FETCH_INV_UPLOADS_START = 'FETCH_INV_UPLOADS_START';
export const FETCH_INV_UPLOADS_END = 'FETCH_INV_UPLOADS_END';

export const FETCH_PRODUCTS_BY_TYPES_START = 'FETCH_PRODUCTS_BY_TYPES_START';
export const FETCH_PRODUCTS_BY_TYPES_END = 'FETCH_PRODUCTS_BY_TYPES_END';

export const GET_SETTINGS = 'GET_SETTINGS';

export const SYNC_SETTING_QRCODE = 'SYNC_SETTING_QRCODE';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js